"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m2.356 5.42 5.648.01 5.648-.01-5.648-4.205L2.356 5.42ZM8.326.106l7.277 5.418a.543.543 0 0 1 .19.604.543.543 0 0 1-.512.372h-.34v6.916a.54.54 0 0 1-.54.54H9.33v-1.08h4.529V6.502l-5.856.01h-.001l-5.824-.01v6.374h4.814v-.571H6.99v-2.03a.54.54 0 0 1 .54-.542h1.746v1.082H8.074v2.601a.54.54 0 0 1-.541.54H1.638a.54.54 0 0 1-.541-.54V6.5h-.37a.543.543 0 0 1-.513-.37.543.543 0 0 1 .19-.604L7.682.106a.543.543 0 0 1 .646 0Zm3.668 12.175h1.082V6.923h-1.082v5.358Zm-8.019 0H2.893V6.923h1.082v5.358Zm1.93 0H4.823V6.923h1.082v5.358Zm5.242 0h-1.082V6.923h1.082v5.358ZM.92 16h14.17v-1.082H.92V16Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m2.64 8.29 9.36.016 9.36-.015L12 1.32 2.64 8.29ZM12.352.117l11.132 8.289a.587.587 0 0 1-.35 1.06h-.758v10.82a.589.589 0 0 1-.588.588H14.03v-1.176h7.17V9.468l-9.2.014h-.002l-9.15-.014v10.229h7.843v-1.113h-.005V15.48c0-.325.264-.588.59-.588h2.67v1.176h-2.078v4.218a.588.588 0 0 1-.588.588H2.26a.589.589 0 0 1-.589-.588V9.465H.868a.588.588 0 0 1-.35-1.06L11.647.116a.588.588 0 0 1 .703 0ZM5.598 18.548H4.42v-8.196h1.177v8.196Zm2.953 0H7.373v-8.196h1.178v8.196Zm9.794 0h1.178v-8.196h-1.178v8.196Zm-1.775 0h-1.177v-8.196h1.177v8.196ZM1.162 24h21.676v-1.177H1.162V24Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m3.521 11.054 12.48.02 12.478-.02L16 1.762 3.521 11.054ZM16.468.155 31.31 11.206a.784.784 0 0 1-.467 1.413l-1.009.002v14.426a.785.785 0 0 1-.785.784H18.707v-1.569h9.558V12.624l-12.264.02H16l-12.2-.02v13.638h10.457V24.78h-.006v-4.14c0-.434.352-.785.785-.785h3.561v1.57h-2.77v5.623a.784.784 0 0 1-.785.784H3.015a.785.785 0 0 1-.785-.784V12.621l-1.073-.002a.784.784 0 0 1-.467-1.413L15.531.156a.785.785 0 0 1 .937 0ZM7.464 24.731H5.895V13.802h1.57v10.929Zm3.937 0h-1.57V13.802h1.57v10.929Zm13.06 0h1.57V13.802h-1.57v10.929Zm-2.368 0h-1.569V13.802h1.57v10.929ZM1.55 31.999h28.901v-1.57h-28.9V32Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.394 16.743 24 16.774l19.606-.031L24 2.144 4.394 16.743ZM24.57.19l22.48 16.738a.955.955 0 0 1-.569 1.72l-1.762.002v22.083a.954.954 0 0 1-.954.954H28.1v-1.909h14.71V18.653l-18.808.03h-.003l-18.713-.03v21.125h16.307v-2.48h-.01v-6.27c0-.528.428-.955.955-.955h5.394v1.908h-4.43v8.752a.954.954 0 0 1-.955.954H4.332a.954.954 0 0 1-.955-.954V18.65l-1.858-.002a.954.954 0 0 1-.568-1.72L23.431.19a.952.952 0 0 1 1.14 0ZM10.836 37.226H8.927V20.673h1.91v16.553Zm5.963 0h-1.908V20.673h1.908v16.553Zm20.25 0h1.909V20.673h-1.91v16.553Zm-4.055 0h-1.909V20.673h1.91v16.553ZM2.113 48h43.774v-1.91H2.113V48Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.858 22.324 32 22.366l26.142-.042L32 2.859 5.858 22.324ZM32.76.253 62.733 22.57a1.273 1.273 0 0 1-.758 2.293l-2.35.003V54.31c0 .703-.57 1.272-1.272 1.272H37.466v-2.545H57.08V24.87l-25.078.04h-.004l-24.95-.04v28.167H28.79v-3.306h-.012V41.37c0-.703.57-1.273 1.272-1.273h7.192v2.545h-5.907V54.31c0 .703-.57 1.272-1.272 1.272H5.776a1.272 1.272 0 0 1-1.273-1.272V24.867l-2.478-.003a1.272 1.272 0 0 1-.757-2.293L31.24.253a1.27 1.27 0 0 1 1.52 0ZM14.448 49.634h-2.545v-22.07h2.545v22.07Zm7.951 0h-2.545v-22.07h2.545v22.07Zm26.999 0h2.545v-22.07h-2.545v22.07Zm-5.406 0h-2.545v-22.07h2.545v22.07ZM2.817 64h58.365v-2.545H2.817V64Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBank = function IconBank(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Bank' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Bank"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBank.sizes = [16, 24, 32, 48, 64];
IconBank.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBank;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Bank.js
// module id = 1663
// module chunks = 0